module.exports = __webpack_public_path__ + "static/media/testimonial_bg_two.508d6210.png";